import Popover from '@ui/popover/popover';
import Container from '@ui/container/container';
import Button from '@ui/buttons/button/button';
import Text from '@ui/text/text/text';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { generateBorderDashSvg } from '@/micros/edit-project/helpers/constants/border-constants';
import { VideoType } from '@/types/video.types';
import { Dispatch, SetStateAction } from 'react';

type TAddVideoPopoverProps = {
  isUpdatingBroadcastType: boolean;
  open?: boolean;
  setShowAddPopover: Dispatch<SetStateAction<boolean>>;
  onSelect: (selectedOption: VideoType | null) => void;
};

const AddVideoPopover = ({ isUpdatingBroadcastType, open, setShowAddPopover, onSelect }: TAddVideoPopoverProps) => {
  const handleSelect = (opt: VideoType | null) => {
    onSelect(opt);
  };

  return (
    <Container className="flex-1" borderRadius="8px" background="var(--global-cont-1)">
      <Popover
        open={open}
        onClose={() => setShowAddPopover((prev) => !prev)}
        cycleWithArrowKeys
        backgroundColor="var(--gray-700)"
        contentClassName="margin-t-4"
        radius="12px"
        inheritRadius
        width="auto"
        renderTriggerButton={() => {
          return (
            <Container height="84px" width="100%" className="flex ai-center jc-center padding-12">
              <Button
                backgroundColor="var(--gray-1000)"
                width="100%"
                height="100%"
                disabled={isUpdatingBroadcastType}
                style={{
                  background: `url(${generateBorderDashSvg('#9B97A1', 8)})`,
                }}
                borderRadius="8px"
                className="flex ai-center jc-center gap-6"
                onClick={() => setShowAddPopover((prev) => !prev)}
              >
                <Icon name={ICONS.ADD} size={12} />
                <Text className="L2" color="var(--gray-100)">
                  Add Video
                </Text>
              </Button>
            </Container>
          );
        }}
      >
        <Button
          backgroundColor="var(--gray-800)"
          hoverBackgroundColor="var(--gray-700)"
          outlineOnFocus={false}
          className="flex ai-center gap-10 radius-0 width-100-percent height-60 padding-v-8 padding-h-12"
          onClick={() => handleSelect(VideoType.recorded)}
        >
          <Container className="width-18">
            <Icon name={ICONS.ADD} size={20} />
          </Container>
          <Container className="flex-column">
            <Text className="P2" color="var(--gray-100)">
              Add Video
            </Text>
            <Text className="L2" color="var(--gray-300)">
              Add a video from your channel content or upload a file up to 5 GB
            </Text>
          </Container>
        </Button>
        <Button
          backgroundColor="var(--gray-800)"
          hoverBackgroundColor="var(--gray-700)"
          outlineOnFocus={false}
          className="flex ai-center gap-10 radius-0 width-100-percent height-60 padding-v-8 padding-h-12"
          onClick={() => handleSelect(VideoType.url)}
        >
          <Container className="width-18">
            <Icon name={ICONS.CHAIN_LINK} size={20} />
          </Container>
          <Container className="flex-column">
            <Text className="P2" color="var(--gray-100)">
              Link Video
            </Text>
            <Text className="L2" color="var(--gray-300)">
              Use YouTube, Vimeo, Wistia, Mixcloud, Dailymotion or Twitch link
            </Text>
          </Container>
        </Button>
        <Button
          backgroundColor="var(--gray-800)"
          hoverBackgroundColor="var(--gray-700)"
          outlineOnFocus={false}
          className="flex ai-center gap-10 radius-0 width-100-percent height-60 padding-v-8 padding-h-12"
          onClick={() => handleSelect(VideoType.embed)}
        >
          <Container className="width-18">
            <Icon name={ICONS.EMBED} size={20} />
          </Container>
          <Container className="flex-column">
            <Text className="P2" color="var(--gray-100)">
              Embed iframe
            </Text>
            <Text className="L2" color="var(--gray-300)">
              Add video via HTML embed code
            </Text>
          </Container>
        </Button>
      </Popover>
    </Container>
  );
};

export default AddVideoPopover;
